<template>
  <div>
    <p style="text-align: left; padding-left: 10px" class="italics">
      Written RoundTable Trends
    </p>
    <div v-show="online_loading" style="margin: 20px">
      <span class="pl-caption">loading</span>
      <i class="fa fa-cog fa-spin fa-fw"></i>
    </div>
    <trending-online-roundtables
      v-show="!online_loading"
      :onlineTrendingData="online_trending_data"
    />

    <p style="text-align: left; padding-left: 10px" class="italics">
      Verbal RoundTable Trends
    </p>
    <div v-show="live_loading" style="margin: 20px">
      <span class="pl-caption">loading</span>
      <i class="fa fa-cog fa-spin fa-fw"></i>
    </div>
    <trending-live-discussions
      v-show="!live_loading"
      :liveTrendingData="live_trending_data"
    />
  </div>
</template>
<!--
  JAVASCRIPT
-->
<script lang="babel">
  import trendingOnlineRoundtables from 'components/dataVisualization/d3js/trendingComments';
  import trendingLiveDiscussions from 'components/dataVisualization/d3js/trendingTurns';
  import fetchTrendingLive from 'services/courses/fetchTrendingLive';
  import fetchTrendingOnline from 'services/courses/fetchTrendingOnline';

  export default {
    data() {
      return {
        online_trending_data: [],
        online_loading: true,
        live_trending_data: [],
        live_loading: true,
      };
    },
    props: [],
    components: {
      trendingOnlineRoundtables,
      trendingLiveDiscussions,
    },
    mounted() {
      const { courseID, studentID } = this.$route.params;
      fetchTrendingOnline(courseID, studentID)
      .then((res) => {
        this.online_trending_data = res;
        this.online_loading = false;
      })
      .catch(console.err);
      fetchTrendingLive(courseID, studentID)
      .then((res) => {
        this.live_trending_data = res;
        this.live_loading = false;
      })
      .catch(console.err);
    },
  };
</script>
<!--
  CSS
-->
<style lang="scss"></style>



// WEBPACK FOOTER //
// trendingCharts.vue?19acd32a